import React from 'react';
import { Button, Divider, Header, Form, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const Details = ({ obj, language, onChange }) => {
  return (
    <div>
      <Header as="h2">Bloc présentation</Header>
      <Form.Field>
        <Form.Input
          label="Titre principal"
          placeholder="Titre de la page"
          id="main_title"
          value={obj.translations[language.code].main_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Sous-titre"
          placeholder="Sous-titre"
          id="sub_title"
          value={obj.translations[language.code].sub_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Description"
          placeholder="Description"
          id="description"
          value={obj.translations[language.code].description}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Texte du bouton"
          id="cta_label"
          fluid
          label="Label du bouton (optionnel)"
          value={obj.translations[language.code].cta_label}
          onChange={(e) => onChange(e, language.code)}
        />
        <Form.Input
          placeholder="https://..."
          id="cta_url"
          fluid
          label="Adresse cible (optionnel)"
          value={obj.translations[language.code].cta_url}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Group>
      <Header as="h2">Bloc catégories</Header>
      <Form.Field>
        <Form.Input
          label="Titre de la section"
          placeholder="Titre"
          id="section_category_title"
          value={obj.translations[language.code].section_category_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Header as="h2">Bloc offres</Header>
      <Form.Field>
        <Form.Input
          label="Titre de la section"
          placeholder="Titre"
          id="section_offers_title"
          value={obj.translations[language.code].section_offers_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Header as="h2">Bloc historique</Header>
      <Form.Field>
        <Form.Input
          label="Titre de la section"
          placeholder="Titre"
          id="section_historical_title"
          value={obj.translations[language.code].section_historical_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Button.Group fluid>
        <Link
          to="/homepage/history"
          floated="right"
          className="ui button olive"
        >
          <Icon name="chain" /> Modifier les slides historiques
        </Link>
      </Button.Group>
      <Header as="h2">Bloc événements</Header>
      <Form.Field>
        <Form.Input
          label="Titre de la section"
          placeholder="Titre"
          id="section_events_title"
          value={obj.translations[language.code].section_events_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Header as="h2">Bloc infos pratiques</Header>
      <Form.Field>
        <Form.Input
          label="Titre de la section"
          placeholder="Titre"
          id="section_info_title"
          value={obj.translations[language.code].section_info_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Titre de la card"
          placeholder="Titre de la card"
          id="section_info_card_title"
          value={obj.translations[language.code].section_info_card_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Description de la card"
          placeholder="Description de la card"
          id="section_info_card_description"
          value={obj.translations[language.code].section_info_card_description}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Texte du bouton gauche"
          id="section_info_card_cta_l_label"
          fluid
          label="Label du bouton gauche"
          value={obj.translations[language.code].section_info_card_cta_l_label}
          onChange={(e) => onChange(e, language.code)}
        />
        <Form.Input
          placeholder="https://..."
          id="section_info_card_cta_l_url"
          fluid
          label="Adresse cible"
          value={obj.translations[language.code].section_info_card_cta_l_url}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Texte du bouton droit"
          id="section_info_card_cta_r_label"
          fluid
          label="Label du bouton droit"
          value={obj.translations[language.code].section_info_card_cta_r_label}
          onChange={(e) => onChange(e, language.code)}
        />
        <Form.Input
          placeholder="https://..."
          id="section_info_card_cta_r_url"
          fluid
          label="Adresse cible"
          value={obj.translations[language.code].section_info_card_cta_r_url}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Group>
      <Header as="h2">Bloc instagram</Header>
      <Form.Field>
        <Form.Input
          label="Titre de la section"
          placeholder="Titre"
          id="section_social_title"
          value={obj.translations[language.code].section_social_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      {/* <Metadata obj={obj} language={language} onChange={onChange} /> */}
    </div>
  );
};

export default Details;



// WEBPACK FOOTER //
// ./src/components/form/homepage/details.js